(function() {
'use strict';

angular
    .module('core')
    .factory('funcUtil', funcUtil);

function funcUtil($timeout, $q, $rootScope) {
    const service = {
        memoize,
        debounce,
        waitForValue,
        compose
    };

    function has(obj, key) {
        return obj != null && obj.hasOwnProperty(key);
    }

    function memoize(func, hasher) {
        const m = function(...args) {
            const key = args[0];
            const cache = m.cache;
            const address = `${hasher ? hasher(...args) : key}`;
            if (!has(cache, address)) {
                cache[address] = func(...args);
            }
            return cache[address];
        };
        m.cache = {};
        return m;
    }

    function compose(...args) {
        return function(x) {
            let retVal = x;
            for (let i = args.length - 1; i >= 0; i--) {
                retVal = args[i](retVal);
            }
            return retVal;
        };
    }

    /* This is a little bit tricksy in that you call debounce and it *returns* you the function
       that you want to debounce. */
    function debounce(fn, delay) {
        let timer;
        return function(...args) {
            if (timer != null) {
                $timeout.cancel(timer);
            }
            timer = $timeout(() => {
                fn.apply(this, args);
            }, delay);
        };
    }


    function waitForValue(factory) {
        const initalValue = factory();
        if (initalValue) {
            return $q.when(initalValue);
        }
        const defered = $q.defer();
        const watch = $rootScope.$watch(factory, val => {
            if (val) {
                watch();
                defered.resolve(val);
            }
        });
        return defered.promise;
    }

    return service;
}
})();
